import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core'
import { ValidatorFn, Validators } from '@angular/forms'

import { environment } from '../../../../../environments/environment'
import { AbcInput } from '../../../../common/interfaces/abc-input.interface'
import { HTMLInputEvent } from '../../../../common/interfaces/html-input-event.interface'
import { FlashMessageService } from '../../../../common/services/flash-message.service'
import { UploadService } from '../../../../common/services/upload.service'

@Component({
  selector: 'abc-image-input',
  templateUrl: './image-input.component.html',
  styleUrls: ['./image-input.component.scss']
})
export class ImageInputComponent implements AbcInput, OnChanges {
  @Input() label: string
  @Input() placeholder: string
  @Input() helpText: string
  @Input() resourceName: string
  @Input() initialValue: { value: string }
  @Input() showErrors = false
  @Input() validators: ValidatorFn[] = []
  @Input() uniqueId: string

  @Output() valueChanged: EventEmitter<{
    value: string
  }> = new EventEmitter()

  @ViewChild('imageInput') imageInputEl: ElementRef

  imagePath: string
  storagePath: string = environment.storagePath

  fileContent: any
  required: boolean
  loading: boolean

  constructor(
    private uploadService: UploadService,
    private flashMessageService: FlashMessageService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    // Prevent value from being reset if showErrors changes.
    if (
      Object.keys(changes).length === 1 &&
      Object.keys(changes)[0] === 'showErrors'
    ) {
      return
    }

    this.imagePath = this.initialValue.value
    this.required = this.validators.includes(Validators.required)
  }

  // Upload image and update value.
  imageInputEvent(imageInput: HTMLInputEvent) {
    this.loading = true
    this.fileContent = this.imageInputEl.nativeElement.files.item(0)
    this.uploadService
      .uploadImage(this.resourceName, this.fileContent)
      .subscribe(
        (res: { path: string }) => {
          this.loading = false
          this.imagePath = res.path
          this.valueChanged.emit({ value: this.imagePath })
        },
        (err) => {
          this.loading = false
          this.flashMessageService.error(
            `Une erreur à eu lieu lors de l'envoi du fichier`
          )
        }
      )
  }

  removeFile() {
    delete this.imagePath
    this.valueChanged.emit({ value: null })
  }
}
